/* eslint-disable class-methods-use-this */
export class OnlineOfflineSingleton {
  _status: boolean | undefined;
  private static instance: any = null;

  handleOnline = () => {
    this._status = true;
  };

  handleOffline = () => {
    this._status = false;
  };

  get status() {
    return this._status;
  }

  constructor() {
    if (OnlineOfflineSingleton.instance) {
      return OnlineOfflineSingleton.instance;
    }

    this._status = window.navigator.onLine;

    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);

    OnlineOfflineSingleton.instance = this;
  }
}
